type Props = {
  children: React.ReactNode
  className?: string
}

const Li = ({ children, className = '' }: Props) => {
  return (
    <li className={className}>
      <span className="inline-block mr-5 text-blue">&bull;</span>
      {children}
    </li>
  )
}

export default Li
